module.exports = __webpack_public_path__ + "img/burger.a3411f6a.svg";